// @flow

export default (translation: string, equalToField: string) => (value: string, fields: Object) => {
  if (value !== fields[equalToField]) {
    return translation;
  }
  return null;
};
